module.exports = __webpack_public_path__ + "img/engineering.6737de8d.jpg";